/**
 * Firebase SDK initialization for the Microflex CRM web app.
 * Connected to project mfx-2026 (MFX-OS), web app "CRM",
 * hosting site "mfx-crm" (will alias to crm.microflexfilm.com).
 */
import { initializeApp }                           from 'firebase/app';
import { getAuth, connectAuthEmulator }            from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator }  from 'firebase/firestore';
import { getStorage, connectStorageEmulator }      from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator }  from 'firebase/functions';

const cfg = {
  apiKey:            import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain:        import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId:         import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket:     import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId:             import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId:     import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

export const app  = initializeApp(cfg);
export const auth = getAuth(app);
export const db   = getFirestore(app);
export const storage   = getStorage(app);
export const functions = getFunctions(app, 'us-west1');

if (import.meta.env.VITE_USE_EMULATORS === 'true') {
  connectAuthEmulator(auth,    'http://localhost:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, 'localhost', 8080);
  connectStorageEmulator(storage,    'localhost', 9199);
  connectFunctionsEmulator(functions,'localhost', 5001);
  console.info('Firebase: connected to local emulators');
}
